export const temperatureLineDatas = (labels: string[], firstData: number[], secondData: number[]) => {
    return {
        labels: labels,
        datasets: [
            {
                label: "Sıcaklık",
                type: "line",
                data: firstData,
                backgroundColor: "rgb(7, 255, 40)",
                borderColor: "rgb(7, 255, 40)",
                color: ["#fff"],
                fill: false,
                borderWidth: 1.5,
                tension: 0
            },
            {
                label: "Set",
                type: "line",
                data: secondData,
                backgroundColor: "red",
                borderColor: "red",
                color: ["#fff"],
                fill: false,
                borderWidth: 1.5,
                tension: 0
            }
        ]
    }
}

export const temperatureLineOptions = {
    plugins: {
        legend: {
            display: true
        }
    }
}
